module.exports = __webpack_public_path__ + "img/38_13.782606ec.png";